<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat outlined class="pb-0 pt-0">
					<v-card-text class="pb-0">
						<v-row>
							<v-col class="pb-0 pt-0">
								<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">
									{{ $t('titles.candidateBrevets') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pt-0">
								<TheTable
									:additional-filters="candidateBrevetsTable.additionalFilters"
									:default-sort="candidateBrevetsTable.defaultSort"
									:excel="false"
									:fields="candidateBrevetsTable.headers"
									:header-selection-key="'candidate-brevets-headers'"
									:height="candidateBrevetsTable.height"
									:total-records="candidateBrevetsTable.total"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in candidateBrevetsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
									>
										<td v-if="candidateBrevetsTable.selectedHeaders.includes('date')">
											{{
												item.date != null ? item.date.split('-').reverse().join('.') + '.' : ''
											}}
										</td>
										<td v-if="candidateBrevetsTable.selectedHeaders.includes('course_id')">
											{{ item.course.name }}
											{{
												item.course_id == null ? item.course.code + ' ' + item.course.name : ''
											}}
										</td>
										<td v-if="candidateBrevetsTable.selectedHeaders.includes('price')">
											{{
												item.price != null
													? Number.isInteger(item.price)
														? item.price.toLocaleString('hr') + ',00'
														: /^\d+\.\d{1}$/.test(item.price.toString())
														? item.price.toLocaleString('hr') + '0'
														: item.price.toLocaleString('hr')
													: ''
											}}
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'candidateBrevets',
	components: { TheTable },
	data: function () {
		return {
			candidateBrevetsTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.date'),
						value: 'date',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.course'),
						value: 'course_id',
						type: '',
						allowFilter: true,
						sortable: false,
					},
					{
						text: this.$t('fields.price'),
						value: 'price',
						type: '',
						allowFilter: true,
						sortable: false,
					},
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '400px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
		};
	},
	methods: {
		selectHeaders(headers) {
			this.candidateBrevetsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.candidateBrevetsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'candidates-brevets/' + this.$route.params.id,
				request,
				(data, success) => {
					if (success) {
						vm.candidateBrevetsTable.items = data.items;
						vm.candidateBrevetsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			// this.candidateBrevetsTable.height = window.innerHeight - 750 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		window.addEventListener('resize', this.resolveWindowResize);
		// this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
